import { gql } from '@/__generated__';

const GET_DEVICE_ORGANIZATION_FOR_DGA = gql(`#graphql
  query GetDeviceOrganizationForDga($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        organization {
          id
          name
          access
        }
      }
    }
  }
`);

export default GET_DEVICE_ORGANIZATION_FOR_DGA;
